// src\app\GoldenSourceHelper.js

/**
 * 🎯 THE GOLDEN SOURCE NORMALIZER
 * Reusable utility to ensure API-to-UI casing parity.
 * Aligns with existing Auth mapping logic.
 */
export const GoldenSourceHelper = {
  /**
   * Smashes the casing discrepancies by checking both variations.
   * Matches the pattern: m.capabilityCode || m.CapabilityCode
   */
  get: (obj, key) => {
    if (!obj) return null;
    const pascal = key.charAt(0).toUpperCase() + key.slice(1);
    const camel = key.charAt(0).toLowerCase() + key.slice(1);
    return obj[pascal] !== undefined ? obj[pascal] : obj[camel];
  },

  /**
   * Normalizes the standard nrgCore response envelope: { success, message, data }
   *
   */
  normalize: (raw) => {
    if (!raw) return null;

    const success = raw.success ?? raw.Success ?? false;
    const message = raw.message ?? raw.Message ?? "";
    const data = raw.data ?? raw.Data ?? null;

    return {
      success,
      message,
      data,
      // Helper to pull nested properties safely from the 'data' payload
      getProp: (propName) => GoldenSourceHelper.get(data, propName)
    };
  }
};